import { Controller } from "stimulus";

const AJAX_ERROR = 'Something went wrong. Please try again later.';

export default class extends Controller {
  static targets = ['row', 'editButton', 'showButton', 'deactivateButton', 'reactivateButton'];

  add() {
    showSpinner();
  }

  rowTargetConnected() {
    if (!this.selectedRow) this.clearSelection();
  }

  selectRow(event) {
    const row = event.currentTarget;
    if (row.classList.contains('selected')) return;

    this.resetRevealedKeys();
    this.rowTargets.forEach((candidate) => candidate.classList.toggle('selected', candidate === row));

    const inactive = row.classList.contains('inactive');
    this.setEnabled(this.editButtonTarget, !inactive);
    this.setEnabled(this.deactivateButtonTarget, !inactive);
    this.setEnabled(this.reactivateButtonTarget, inactive);

    if (this.hasShowButtonTarget) {
      this.setEnabled(this.showButtonTarget, row.querySelector('.private_key_full') !== null);
    }
  }

  edit(event) {
    event.preventDefault();
    if (this.isDisabled(this.editButtonTarget) || !this.selectedRow) return;

    showSpinner();
    $.get(this.selectedRow.dataset.editUrl);
  }

  toggleFullKey(event) {
    event.preventDefault();
    if (this.isDisabled(this.showButtonTarget) || !this.selectedRow) return;

    $(this.selectedRow).find('.private_key_masked, .private_key_full').toggle();

    const button = $(this.showButtonTarget);
    button.text(button.text() === 'Show' ? 'Hide' : 'Show');
  }

  deactivate(event) {
    event.preventDefault();
    if (this.isDisabled(this.deactivateButtonTarget) || !this.selectedRow) return;

    const url = this.selectedRow.dataset.deactivateUrl;
    if (!url) return;

    $('#dialog-confirm-deactivate-cryptographic-key').remove();

    $('body').append(
      '<div id="dialog-confirm-deactivate-cryptographic-key" title="Deactivate Cryptographic Key">' +
      '<p>Are you sure you want to deactivate this cryptographic key?</p>' +
      '</div>'
    );

    $('#dialog-confirm-deactivate-cryptographic-key').dialog({
      resizable: false,
      draggable: false,
      width: 500,
      modal: true,
      buttons: {
        'Cancel': function() {
          $(this).dialog('close');
        },
        'Deactivate': function() {
          $(this).dialog('close');
          showSpinner();
          $.ajax({
            url: url,
            type: 'DELETE',
            error: function() {
              hideSpinner();
              alert(AJAX_ERROR);
            }
          });
        }
      }
    });
  }

  reactivate(event) {
    event.preventDefault();
    if (this.isDisabled(this.reactivateButtonTarget) || !this.selectedRow) return;

    const url = this.selectedRow.dataset.reactivateUrl;
    if (!url) return;

    showSpinner();
    $.ajax({
      url: url,
      type: 'PUT',
      error: function() {
        hideSpinner();
        alert(AJAX_ERROR);
      }
    });
  }

  clearSelection() {
    this.resetRevealedKeys();
    if (this.hasEditButtonTarget) this.setEnabled(this.editButtonTarget, false);
    if (this.hasDeactivateButtonTarget) this.setEnabled(this.deactivateButtonTarget, false);
    if (this.hasReactivateButtonTarget) this.setEnabled(this.reactivateButtonTarget, false);
    if (this.hasShowButtonTarget) this.setEnabled(this.showButtonTarget, false);
  }

  resetRevealedKeys() {
    $(this.element).find('.private_key_full').hide();
    $(this.element).find('.private_key_masked').show();

    if (this.hasShowButtonTarget) this.showButtonTarget.textContent = 'Show';
  }

  get selectedRow() {
    return this.rowTargets.find((row) => row.classList.contains('selected'));
  }

  isDisabled(button) {
    return button.classList.contains('disabled');
  }

  setEnabled(button, enabled) {
    enabled ? $(button).enableButton() : $(button).disableButton();
  }
}
